import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import "dayjs/locale/es";

import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";

export const supportedLanguages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
] as const;

export type SupportedLanguage = typeof supportedLanguages[number]["code"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: supportedLanguages.map(({ code }) => code),
    nonExplicitSupportedLngs: true,
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    detection: {
      // Restore the user's choice before falling back to browser preferences.
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

const updateDocumentLanguage = (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language.split("-")[0];
  }
};

updateDocumentLanguage(i18n.resolvedLanguage || i18n.language || "en");
i18n.on("languageChanged", updateDocumentLanguage);

export default i18n;
